import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-lg-10 mx-auto" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = {
  key: 0,
  class: "px3 mt-4 mb-5"
}
const _hoisted_4 = {
  key: 1,
  class: "px3 mt-4 mb-5"
}
const _hoisted_5 = { class: "row mt-3" }
const _hoisted_6 = { class: "col-md-8 col-6" }
const _hoisted_7 = {
  key: 0,
  class: "row mb-0"
}
const _hoisted_8 = { class: "col-md-8 col-6" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-xl-6 mb-4" }
const _hoisted_11 = {
  key: 0,
  class: "col-xl-6 mb-4"
}
const _hoisted_12 = {
  class: "btn-group d-flex",
  role: "group",
  "aria-label": "Sex"
}
const _hoisted_13 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_14 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Sex"
}
const _hoisted_15 = {
  class: "btn-group w100",
  role: "group",
  "aria-label": "Are you already taking pension or cash from your pension pots?"
}
const _hoisted_16 = {
  key: 2,
  id: "retirementDateAdvice",
  class: "mb0"
}
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-4" }
const _hoisted_19 = {
  class: "btn-group w-100",
  role: "group",
  "aria-label": "Are you now retired?"
}
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-8 col-6" }
const _hoisted_22 = {
  key: 0,
  class: "row mt-2 mb-2"
}
const _hoisted_23 = { class: "col-md-4 col-6" }
const _hoisted_24 = { class: "col-md-8 col-6" }
const _hoisted_25 = {
  class: "row mb4",
  "aria-label": "Retirement date",
  "aria-labelledby": "retirementDateAdvice"
}
const _hoisted_26 = { class: "form-label" }
const _hoisted_27 = {
  key: 1,
  class: "row"
}
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "mt-3" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 2,
  class: "row"
}
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = {
  key: 3,
  class: "row"
}
const _hoisted_34 = { class: "col" }
const _hoisted_35 = { class: "warningMessage mt-3" }
const _hoisted_36 = { class: "col-lg-7 mx-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_workflow_navigation = _resolveComponent("workflow-navigation")!
  const _component_vue_date_picker = _resolveComponent("vue-date-picker")!
  const _component_radio_button = _resolveComponent("radio-button")!
  const _component_month_and_year = _resolveComponent("month-and-year")!
  const _component_sub_section = _resolveComponent("sub-section")!
  const _component_page_nav = _resolveComponent("page-nav")!
  const _component_contact_us = _resolveComponent("contact-us")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(_component_workflow_navigation, { workflowStage: "You" }),
      _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "skin-page-heading" }, " Your retirement plan ", -1)),
      (_ctx.showSubHeader)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Please enter your personal details along with your retirement date. "))
        : _createCommentVNode("", true),
      (!_ctx.showSubHeader)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Here are your personal details and chosen retirement date. "))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_sub_section, {
      title: "About you",
      showHelp: false,
      mdColCount: "7",
      mbSize: "2"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (!_ctx.canEditBirthdayAndSex)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-md-4 col-6" }, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, "Date of Birth:")
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.dateOfBirthText), 1)
                  ])
                ]),
                (_ctx.canViewSex)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-md-4 col-6" }, [
                        _createElementVNode("p", null, [
                          _createElementVNode("strong", null, "Sex:")
                        ])
                      ], -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.sexText), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", {
                      for: "exampleInputEmail1",
                      class: "form-label"
                    }, "Date of Birth:", -1)),
                    _createVNode(_component_vue_date_picker, {
                      modelValue: _ctx.dateOfBirthModel,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateOfBirthModel) = $event)),
                      placeholder: "Date of Birth",
                      format: "d-MMM-yyyy",
                      "min-date": new Date(_ctx.dateTimeProvider.now().getFullYear() - 100, 0, 1),
                      "max-date": new Date(_ctx.dateTimeProvider.now().getFullYear() - 20, 11, 31),
                      "start-date": new Date(_ctx.dateTimeProvider.now().getFullYear() - 55, 0, 1),
                      "enable-time-picker": false,
                      "auto-apply": "",
                      "no-today": "",
                      "aria-labels": { input: 'Select your date of birth' }
                    }, null, 8, ["modelValue", "min-date", "max-date", "start-date"])
                  ]),
                  (_ctx.canViewSex)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _cache[5] || (_cache[5] = _createElementVNode("label", {
                          for: "sex",
                          class: "form-label w-100"
                        }, "Sex:", -1)),
                        _createElementVNode("div", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSexItems(), (item, i) => {
                            return (_openBlock(), _createBlock(_component_radio_button, {
                              key: i,
                              name: "sex",
                              class: "flex-fill",
                              label: item.text,
                              value: _ctx.sexModel,
                              onChange: _ctx.onChangeSex
                            }, null, 8, ["label", "value", "onChange"]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.showOverFiftyFive)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _cache[6] || (_cache[6] = _createElementVNode("p", null, "Have you already started taking pension or cash from your pension pots?", -1)),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getYesNoItems(), (item, i) => {
                            return (_openBlock(), _createBlock(_component_radio_button, {
                              key: i,
                              name: "alreadyTakingPension",
                              label: item.text,
                              value: _ctx.alreadyTakingPensionModel,
                              onChange: _ctx.onChangeTakingPension
                            }, null, 8, ["label", "value", "onChange"]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64)),
          (_ctx.showRetirementDateAdvice)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("p", null, _toDisplayString(_ctx.retirementDateAdviceText), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.mustConfirmRetired)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("p", null, " You previously told us you wanted to start taking cash or pension from your pension pots in " + _toDisplayString(_ctx.retirementDateText) + ", have you started doing so? ", 1),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getYesNoItems(), (item, i) => {
                        return (_openBlock(), _createBlock(_component_radio_button, {
                          key: i,
                          name: "confirmRetired",
                          label: item.text,
                          value: _ctx.confirmRetiredModel,
                          onChange: _ctx.onConfirmRetired
                        }, null, 8, ["label", "value", "onChange"]))
                      }), 128))
                    ])
                  ])
                ])
              ], 64))
            : (_ctx.retirementDateIsInThePast)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-md-4 col-6" }, [
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", null, "State Pension Age:")
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.statePensionInfoTenseless), 1)
                    ])
                  ]),
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "row" }, [
                    _createElementVNode("div", { class: "col" }, [
                      _createElementVNode("p", null, " You have already started accessing benefits, we will build you a plan for the future, which will update each month. ")
                    ])
                  ], -1))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  (_ctx.retirementDateIsReadOnly)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("p", null, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.text("terminology.retirement-date")) + ":", 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.retirementDateText), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.text("terminology.retirement-date")) + ":", 1),
                    _createVNode(_component_month_and_year, {
                      ref: "retirementDate",
                      monthLabel: "Month",
                      yearLabel: "Year",
                      ariaMonthLabel: "Retirement date month",
                      ariaYearLabel: "Retirement date year",
                      onChange: _ctx.onRetirementDateChange
                    }, null, 8, ["onChange"])
                  ], 512), [
                    [_vShow, !_ctx.retirementDateIsReadOnly]
                  ]),
                  (_ctx.showAgeAtRetirement)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.ageAtRetirementText), 1),
                          (_ctx.showCheckDataAlert)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.text("you.check-data.alert")), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.assumptions)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("p", { innerHTML: _ctx.assumptions }, null, 8, _hoisted_32)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showValidationMessage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.validationMessage), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_36, [
      _createVNode(_component_page_nav, {
        showBack: false,
        onNextClicked: _ctx.onNextClicked,
        "parent-will-handle-next": true,
        "next-link": _ctx.nextLink
      }, null, 8, ["onNextClicked", "next-link"]),
      _createVNode(_component_contact_us, { class: "mt-4" })
    ])
  ]))
}